var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperclip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0095 8.70637V14.7064C10.0095 15.8898 10.9689 16.8492 12.1523 16.8492C13.3358 16.8492 14.2952 15.8898 14.2952 14.7064V8.49208C14.2952 6.2435 12.4724 4.42065 10.2238 4.42065C7.97518 4.42065 6.15234 6.24349 6.15234 8.49208V15.1349C6.15234 18.4486 8.83864 21.1349 12.1523 21.1349C15.4661 21.1349 18.1523 18.4486 18.1523 15.1349V8.70637",
    stroke: "#141F35",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip);
export default __webpack_public_path__ + "static/media/paperclip.dabbef63d53844af3ca4107bda45127d.svg";
export { ForwardRef as ReactComponent };